<template>
  <div class="rootDiv">
    <img :src="viewModel.jQTP" :width="width" alt="">
    <div class="title-div">
      <span>{{ viewModel.jQMC }}</span>
    </div>
    <Cell class="cell" title="等级">
      <span>{{ viewModel.jQDJ }}</span>
    </Cell>
    <Cell class="cell" title="评定年份">
      <span>{{ viewModel.pDNF }}</span>
    </Cell>
    <Cell class="cell" title="城市">
      <span>{{ viewModel.jQCS }}</span>
    </Cell>
    <Cell class="cell" title="地址">
      <span>{{ viewModel.jQDZ }}</span>
    </Cell>
    <Cell class="cell" title="经度">
      <span>{{ viewModel.jQJD }}</span>
    </Cell>
    <Cell class="cell" title="纬度">
      <span>{{ viewModel.jQWD }}</span>
    </Cell>
    <Cell class="cell" title="门票价格" v-if="viewModel.mPJG">
      <span>{{ viewModel.mPJG }}</span>
    </Cell>
    <Cell class="cell" title="开放时间" v-if="viewModel.kFSJ">
      <span>{{ viewModel.kFSJ }}</span>
    </Cell>
    <Cell class="cell" title="景区电话" v-if="viewModel.jQDH">
      <span>{{ viewModel.jQDH }}</span>
    </Cell>
    <Cell title="查看地图"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goMap()"></Cell>
    <Cell title="百度百科"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goBaiDu(viewModel.jQMC )"></Cell>
  </div>
</template>

<script>
import {Cell, Indicator} from "mint-ui";

export default {
  name: "ViewDetails",
  data() {
    return {
      viewModel: {},
      width: document.documentElement.clientWidth,
      getDetailsUrl: '/api/whhly/getDetails',
    }
  },
  components: {
    Cell
  },
  mounted() {
    if (this.$route.params.viewModel === undefined && this.$route.params.id === undefined) {
      this.$router.go(-1)
    } else if (this.$route.params.viewModel !== undefined)
      this.viewModel = this.$route.params.viewModel
    else
      this.getDetails(this.$route.params.id)
  },
  methods: {
    goMap() {
      if (this.viewModel.jQJD === 0 || this.viewModel.jQWD === 0) {
        this.$messagebox.alert('缺少经纬度坐标')
      } else {
        let list = []
        let item = {title: this.viewModel.jQMC, data: {jQJD: this.viewModel.jQJD, jQWD: this.viewModel.jQWD}}
        list.push(item)
        this.$router.replace({name: 'm_view', query: {point: list}})
      }
    },
    goBaiDu(name) {
      window.location.href = "https://baike.baidu.com/item/" + name
    },
    getDetails(id) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getDetailsUrl,
        params: {id: id},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.viewModel = response.data['responseData']
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title-div {
  background-color: #8450C5;
  margin-right: -0.5rem;
  padding-bottom: 5px;
  margin-top: -0.1rem;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
  margin-left: -0.5rem;
}

.cell {
  text-align: left;
}

/deep/ .mint-cell-title {
  min-width: 80px;
}
</style>
